import {
  Button,
  InputContainer,
  InputOption,
  InputSelect,
  InputNumber,
} from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";

import { useForm } from "react-hook-form";
import { useSupplierStorefrontAvailabilityNotificationCreate } from "../../../../hooks/api/v2/storefrontAvailability/notifications/useSupplierStorefrontAvailabilityNotificationCreate";

export const AddAvailabilityNotificationDialog = ({
  active,
  intervalMarker,
  supplierId,
  onDismiss,
}: {
  active: boolean;
  supplierId: number;
  intervalMarker: "start" | "end";
  onDismiss: () => void;
}) => {
  const createNotificationMutation =
    useSupplierStorefrontAvailabilityNotificationCreate(supplierId);

  const { register, handleSubmit, reset } = useForm<{
    type: "email" | "app";
    triggerOffset: number | null;
    units: "hours" | "days";
  }>({
    defaultValues: {
      type: "app",
      triggerOffset: null,
      units: "days",
    },
    shouldUseNativeValidation: true,
  });

  const handleDismiss = () => {
    reset();
    onDismiss();
  };

  return (
    <Dialog active={active} onDismiss={handleDismiss}>
      <DialogNavigation
        title="Create storefront availability reminder"
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={handleDismiss}
      />
      <DialogContent>
        <form
          onSubmit={handleSubmit(({ triggerOffset, units }) => {
            if (triggerOffset === null) {
              return;
            }

            const triggerOffsetHours =
              units === "days" ? triggerOffset * 24 : triggerOffset;
            const triggerOffsetMs = triggerOffsetHours * 60 * 60 * 1000;

            createNotificationMutation.mutate(
              {
                type: "app",
                triggerOffsetMs,
                intervalMarkerType: intervalMarker,
              },
              {
                onSuccess: handleDismiss,
              },
            );
          })}
          className="flex flex-col gap-4"
        >
          <div className="flex items-center gap-2">
            <InputContainer>
              <InputSelect
                disabled
                value={"app"}
                {...register("type", { required: true })}
              >
                <InputOption value={"app"}>Notification</InputOption>
              </InputSelect>
            </InputContainer>

            <div className="flex items-center gap-1">
              <InputContainer>
                <InputNumber
                  required={true}
                  {...register("triggerOffset", {
                    required: true,
                    min: 0,
                    valueAsNumber: true,
                  })}
                />
              </InputContainer>
              <InputContainer>
                <InputSelect {...register("units", { required: true })}>
                  <InputOption value={"days"}>days</InputOption>
                  <InputOption value={"hours"}>hours</InputOption>
                </InputSelect>
              </InputContainer>
            </div>
          </div>

          <div className="flex items-center justify-end">
            <Button type="submit">Confirm</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
